import { useState } from "react"
import Modal from 'react-modal';
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { TipoOperacao } from "../../../Obras/newObra/IObra";
import { InstrucoesSerrote } from "./Serrote";
import { InstrucoesCnc } from "./CNC";
import { InstrucoesConvencionais } from "./Convencionais";
import { InstrucoesAcabamento } from "./Acabamento";
import { InstrucoesProjeto } from "./Projeto";
import { InstrucoesControloEQualidade } from "./ControloEQualidade";
import { InstrucoesTratamento } from "./Tratamento";
import { InstrucoesSubcontratacao } from "./Subcontratacao";
import { InstrucoesExpedicao } from "./Expedicao";


export function InstrucoesTrabalho({ selectedOperacao }: { selectedOperacao: TipoOperacao | null }) {

    const [isOpen, setIsOpen] = useState(false);

    const instrucoesTrabalho = {
        [TipoOperacao.SERROTE]: <InstrucoesSerrote/>,
        [TipoOperacao.CNC]: <InstrucoesCnc/>,
        [TipoOperacao.CONVENCIONAIS]: <InstrucoesConvencionais/>,
        [TipoOperacao.ACABAMENTO]: <InstrucoesAcabamento/>,
        [TipoOperacao.PROJETO]: <InstrucoesProjeto/>,
        [TipoOperacao.CONTROLO_QUALIDADE]: <InstrucoesControloEQualidade/>,
        [TipoOperacao.TRATAMENTO]: <InstrucoesTratamento/>,
        [TipoOperacao.SUBCONTRATACAO]: <InstrucoesSubcontratacao/>,
        [TipoOperacao.EXPEDICAO]: <InstrucoesExpedicao/>
    }


    return (
        <>
            {
                isOpen ?
                    <Modal className={"justify-self-center justify-center flex w-full h-full p-32 px-20 z-[1000]"} isOpen={isOpen}>
                        < div className="bg-white opacity-100 flex flex-col w-4/5 rounded-md shadow-lg z-[1200] h-fit" >
                            <div className="flex w-full justify-between  bg-rodrimaq-red rounded-t-md p-3">
                                <div className="text-white font-bold">Instruções de trabalho para {selectedOperacao}</div>
                                <div className="text-white cursor-pointer hover:underline" onClick={() => setIsOpen(false)}>Fechar</div>
                            </div>
                            <div className="p-5 px-12">
                               {selectedOperacao ? instrucoesTrabalho[selectedOperacao] : null}
                            </div>
                        </div >
                    </Modal >
                    : null
            }
            <div className="mt-3">
                <CustomButtonSimple text="Instruções de trabalho" onClick={()=> setIsOpen(true)}/>
            </div>
        </>
    )



}